import React, { useEffect, useState } from "react";

const DEFAULT_ANDROID_DOWNLOAD = "https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=3722970";
const IOS_DOWNLOAD = "https://apps.apple.com/cn/app/%E9%80%9A%E4%BF%A1%E4%BA%91/id6572293585";

function getQueryParam(name) {
  const url = new URL(window.location.href);
  return url.searchParams.get(name);
}

function isAndroid() {
  return /android/i.test(navigator.userAgent);
}

function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

function isWeChat() {
  return /micromessenger/i.test(navigator.userAgent);
}

export default function OpenAppPage() {
  const [showFail, setShowFail] = useState(false);
  const [androidDownload, setAndroidDownload] = useState(DEFAULT_ANDROID_DOWNLOAD);
  const pkgname = "com.zuime.txy";//getQueryParam("pkgname");
  const androidScheme = getQueryParam("android_scheme");
  const defaultPage = getQueryParam("default_page");
  const siteUrl = `${window.location.origin}/${defaultPage}`;

  // 拉取安卓下载链接
  useEffect(() => {
    fetch('/hopeapi/config/setting')
      .then(res => res.json())
      .then(data => {
        const found = data?.data?.find(item => item.configKey === 'txsc_h5_dl_android_m_link');
        if (found && found.configValue) {
          setAndroidDownload(found.configValue);
        }
      });
  }, []);

  // 微信 JS-SDK 动态引入与 wx.config 初始化
  useEffect(() => {
    if (isWeChat()) {
      const script = document.createElement('script');
      script.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js';
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        if (window.wx) {
          // 获取签名参数
          const url = window.location.href.split('#')[0];
          fetch(`/hopeapi/txscmpopen/wechat/signature?url=${encodeURIComponent(url)}`)
            .then(res => res.json())
            .then(data => {
              if (data && data.status === 'success') {
                window.wx.config({
                  debug: false,
                  appId: data.appId,
                  timestamp: Number(data.timestamp),
                  nonceStr: data.nonceStr,
                  signature: data.signature,
                  jsApiList: [],
                  openTagList: ['wx-open-launch-app']
                });
              }
            });
        }
      };
      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  useEffect(() => {
    let timer;
    if (isWeChat()) {
      setShowFail(true);
      return;
    }
    if (isAndroid() && androidScheme) {
      window.location.href = androidScheme;
      timer = setTimeout(() => setShowFail(true), 2000);
    } else if (isIOS() && androidScheme) {
      window.location.href = androidScheme;
      timer = setTimeout(() => setShowFail(true), 2000);
    }
    // 非手机端不再直接跳转
    return () => clearTimeout(timer);
  }, [androidScheme, siteUrl]);

  // 样式定义
  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
    color: '#222',
    padding: '24px',
  };
  const cardStyle = {
    background: '#fff',
    borderRadius: '16px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    padding: '32px 24px',
    maxWidth: '360px',
    width: '100%',
    textAlign: 'center',
  };
  const titleStyle = {
    fontSize: '1.4rem',
    fontWeight: 600,
    marginBottom: '16px',
    color: '#2d5be3',
  };
  const descStyle = {
    fontSize: '1rem',
    marginBottom: '24px',
    color: '#444',
  };
  const btnGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    marginTop: '12px',
  };
  const btnStyle = {
    display: 'block',
    padding: '12px 0',
    borderRadius: '8px',
    border: 'none',
    background: 'linear-gradient(90deg, #2d5be3 0%, #4f8cff 100%)',
    color: '#fff',
    fontWeight: 500,
    fontSize: '1rem',
    textDecoration: 'none',
    transition: 'background 0.2s',
    boxShadow: '0 2px 8px rgba(77, 125, 255, 0.08)',
  };
  const btnSecondaryStyle = {
    ...btnStyle,
    background: 'linear-gradient(90deg, #bdbdbd 0%, #e0e0e0 100%)',
    color: '#444',
    boxShadow: '0 2px 8px rgba(180, 180, 180, 0.08)',
  };
  const linkStyle = {
    color: '#2d5be3',
    textDecoration: 'underline',
    fontSize: '0.98rem',
    marginTop: '8px',
  };

  // 微信内专用提示
  if (isWeChat()) {
    // 需要根据实际APP信息填写 appid、scheme、参数等
    // 参考文档：https://developers.weixin.qq.com/doc/oplatform/Mobile_App/Launching_app.html
    // 这里以安卓举例，iOS可用 universal link
    const extinfo = JSON.stringify({
      android_schema: androidScheme || '',
      ios_universal_link: IOS_DOWNLOAD
    });
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', fontFamily: 'Segoe UI, Arial, sans-serif', color: '#222', padding: '24px'
      }}>
        <div style={{
          background: '#fff', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '32px 24px', maxWidth: '360px', width: '100%', textAlign: 'center'
        }}>
          <div style={{ fontSize: '1.2rem', fontWeight: 600, color: '#2d5be3', marginBottom: '16px' }}>一键打开通信云APP</div>
          <div style={{ fontSize: '1rem', color: '#444', marginBottom: '16px' }}>
            如果已安装APP，点击下方按钮直接打开。<br />
            未安装可选择下载或网页访问。
          </div>
          {/* 微信开放标签唤起APP，使用 dangerouslySetInnerHTML 渲染 */}
          <div style={{ margin: '24px 0' }}
            dangerouslySetInnerHTML={{
              __html: `
                <wx-open-launch-app
                  appid="wxabf6f04b58f4b888"
                  extinfo='${extinfo}'
                  style="display:block;width:100%;height:48px"
                >
                  <script type="text/wxtag-template">
                    <button style="width:100%;height:48px;background:#2d5be3;color:#fff;border:none;border-radius:8px;font-size:1rem;">一键打开APP</button>
                  </script>
                </wx-open-launch-app>
              `
            }}
          />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <a href={androidDownload} style={{ color: '#2d5be3', textDecoration: 'underline', fontSize: '1rem' }} target="_blank" rel="noopener noreferrer">下载安卓APP</a>
            <a href={IOS_DOWNLOAD} style={{ color: '#2d5be3', textDecoration: 'underline', fontSize: '1rem' }} target="_blank" rel="noopener noreferrer">下载苹果APP</a>
            <a href={siteUrl} style={{ color: '#444', textDecoration: 'underline', fontSize: '1rem' }} target="_blank" rel="noopener noreferrer">网页访问</a>
          </div>
        </div>
      </div>
    );
  }

  if (!showFail && (isAndroid() || isIOS())) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={titleStyle}>正在尝试打开通信云APP…</div>
          <div style={descStyle}>请稍候，如果未自动跳转，将为您提供其他访问方式。</div>
        </div>
      </div>
    );
  }

  if (isAndroid()) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={titleStyle}>未检测到APP</div>
          <div style={descStyle}>您还未安装【通信云】应用</div>
          <div style={btnGroupStyle}>
            <a href={androidDownload} style={btnStyle} target="_blank" rel="noopener noreferrer">点击下载通信云安卓APP</a>
            <a href={siteUrl} style={btnSecondaryStyle} target="_blank" rel="noopener noreferrer">点此继续使用网页访问</a>
          </div>
        </div>
      </div>
    );
  }

  if (isIOS()) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={titleStyle}>未检测到APP</div>
          <div style={descStyle}>您还未安装【通信云】应用</div>
          <div style={btnGroupStyle}>
            <a href={IOS_DOWNLOAD} style={btnStyle} target="_blank" rel="noopener noreferrer">点击下载通信云苹果APP</a>
            <a href={siteUrl} style={btnSecondaryStyle} target="_blank" rel="noopener noreferrer">点此继续使用网页访问</a>
          </div>
        </div>
      </div>
    );
  }

  // 非手机端提示
  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={titleStyle}>下载APP访问更便捷</div>
        <div style={descStyle}>推荐安装【通信云】APP，体验更流畅、功能更丰富。</div>
        <div style={btnGroupStyle}>
          <a href={androidDownload} style={btnStyle} target="_blank" rel="noopener noreferrer">下载通信云安卓APP</a>
          <a href={IOS_DOWNLOAD} style={btnStyle} target="_blank" rel="noopener noreferrer">下载通信云苹果APP</a>
          <a href={siteUrl} style={btnSecondaryStyle} target="_blank" rel="noopener noreferrer">点此继续使用网页访问</a>
        </div>
      </div>
    </div>
  );
} 